import React, { useRef } from 'react';
import Slider from 'react-slick';
import InvisibleToInvincibleCard from './InvisibleToInvincibleCard';
import 'slick-carousel/slick/slick.css';
import target from './icons/target.json';
import competition from './icons/competition.json';
import cost from './icons/cost.json';

const InvisibleToInvincibleSlider = () => {
  const slider = useRef();

  const settings = {
    initialSlide: 0,
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>
        {`
          .slick-list {
            overflow: hidden;  
          }
          .invisible-to-invincible-cards-slider .slick-track {
            display: flex;
            align-items: baseline;  
          }
          .slick-slide {
            outline: none;
          }
          .slick-slide div {
            outline: none;
          }
          .custom-dots {
            display: flex !important;
            justify-content: center;
          }
          .custom-dots li {
            position: relative;
            margin: 0 3px;
            margin-top: 20px;
            width: 50px;
            height: 2px;
            background-color: #C4C4C4;
            overflow: hidden;
          }
          .invisible-to-invincible-cards-slider .custom-dots li.slick-active {
            background-color: #D9A8E5;
          }
          .custom-dots li button {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
          }
        `}
      </style>
      <Slider ref={slider} {...settings} className="invisible-to-invincible-cards-slider w-full z-10 ">
        <div className=" flex pr-[30px]">
          <InvisibleToInvincibleCard
            animationData={cost}
            animationWidth={65}
            animationHeight={65}
            headerText="Reducing Marketing Costs"
            text="Investing in a professional SEO services company will be the best way to increase your marketing efforts cost-effectively. When you optimize your content, you stand a chance to get organic traffic, reducing the need for paid advertising. This means huge savings with either the maintenance of the current reach or an increase in reach."
          />
        </div>
        <div className=" flex pr-[30px]">
          <InvisibleToInvincibleCard
            animationData={competition}
            animationWidth={75}
            animationHeight={65}
            headerText="Overcoming Industry Competition"
            text="Stay ahead with our unique SEO services strategies that offer guaranteed results. Make sure you target high-competition keywords with your message. Rely on our link-building and technical SEO strategies to up your ranks. We'll ensure you don't just compete—you lead."
          />
        </div>
        <div className=" flex pr-[30px]">
          <InvisibleToInvincibleCard
            animationData={target}
            animationWidth={65}
            animationHeight={65}
            headerText="Connecting with Local Targets"
            text="Our approach to search optimization services connects you to customers needing your service right where they are. Strategic localization helps businesses be more visible in the community. This attracts more customers and increases local engagement through effective white hat SEO practices. National SEO services play a key role in achieving this. We will optimize content for both regional keywords and have your business listed in local directories"
          />
        </div>
      </Slider>
    </>
  );
};

export default InvisibleToInvincibleSlider;
